import React from 'react';
import Layout from '../../components/ui/Layout';
import { Container } from 'react-bootstrap';
import { CONTACT_INFO } from '../../constants/contact';

export default function RefundPolicy() {
  return (
    <Layout>
      <Container className="mt-4">
        <h1>Refund Policy</h1>
        <p>We want you to be satisfied with your purchase. If you are not completely satisfied, please review our refund policy below.</p>
        <h4>Eligibility for Refunds</h4>
        <ul>
          <li>Refund requests must be made within 7 days of purchase.</li>
          <li>Products must be unused and in the same condition as received.</li>
        </ul>
        <h4>How to Request a Refund</h4>
        <ul>
          <li>Contact us at {CONTACT_INFO.email} with your order details and reason for refund.</li>
          <li>We will review your request and respond within 3 business days.</li>
        </ul>
        <h4>Contact Us</h4>
        <p>If you have any questions about our Refund Policy, please contact us at {CONTACT_INFO.email}.</p>
      </Container>
    </Layout>
  );
} 